<template>
    <div div style="padding-bottom: 3%; line-height: 3em;" class="adway_subheaders">
        <div>Thank you for signing up to Earn With Adway. </div>
        <div>Someone from our Driver Operations Team will contact you soon!</div>
    </div>
</template>

<script>
export default {

}
</script>
